import PropTypes from 'prop-types';

export default function DownloadFileLabel({ extension, fileSize, label }) {
  return (
    <>
      {label}
      {' ('}
      <span className="u-text-uppercase">{extension}</span>
      {', '}
      {fileSize}
      {')'}
    </>
  );
}

DownloadFileLabel.propTypes = {
  extension: PropTypes.string.isRequired,
  fileSize: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
